<script setup lang="ts">
defineProps<{
  value: string;
}>();

const open = ref(false);

function toggleOpen() {
  open.value = !open.value;
}
</script>

<template>
  <div class="flex items-center justify-between py-2 gap-2">
    <slot />

    <label :for="value" class="flex-1 text-sm font-normal text-[#4B5563]">
      {{ value }}
    </label>

    <div @click="toggleOpen">
      <i
        :class="[
          'pi cursor-pointer',
          open ? 'pi-angle-down' : 'pi-angle-right',
        ]"
      ></i>
    </div>
  </div>

  <ul class="space-y-[2px]" v-if="open">
    <slot name="listItem"></slot>
  </ul>
</template>
